import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../lib";
import { failureHash } from "./post.static";
export class ApiEpPost {
}
ApiEpPost.count = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v2/post/count`,
    method: "GET",
    query: req.query,
}, failureHash);
ApiEpPost.countDaily = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v2/post/count-daily`,
    method: "GET",
    query: req.query,
}, failureHash);
ApiEpPost.create = (req) => apiRequest({
    body: req.body,
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v2/post/`,
    method: "POST",
}, failureHash);
ApiEpPost.delete = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v2/post/${req.path.id}`,
    method: "DELETE",
}, failureHash);
ApiEpPost.list = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v2/post/`,
    method: "GET",
    next: req === null || req === void 0 ? void 0 : req.next,
    query: req === null || req === void 0 ? void 0 : req.query,
}, failureHash);
ApiEpPost.retrieve = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v2/post/${req.path.id}`,
    method: "GET",
}, failureHash);
ApiEpPost.update = (req) => apiRequest({
    body: req.body,
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v2/post/${req.path.id}`,
    method: "PUT",
}, failureHash);
ApiEpPost.updatePartial = (req) => apiRequest({
    body: req.body,
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v2/post/${req.path.id}`,
    method: "PATCH",
}, failureHash);
//# sourceMappingURL=post.js.map